import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import FeedbackCard from "./FeedbackCard";

const feedbacks = [
  {
    id: 1,
    name: "Kelly Silva",
    message: "Melhor atendimento que ja tive em.uma concessionária. Thiago parabéns por todos os trâmites feito com muito carinho e atenção.",
    rating: 5,
  },
  {
    id: 2,
    name: "Luiz Antonio Rosa",
    message: "Ótimo atendimento, faz de tudo para agradar o cliente. Comprei meu carro e quando for trocar vou procurá-los novamente",
    rating: 5,
  },
  {
    id: 3,
    name: "Giovanna Ananias",
    message: "Loja muito boa! Super recomendo! Recomendo também a ser atendido pelo Vendedor Caio! Foi super atencioso, educado, simpático… amei demais!",
    rating: 5,
  },
  {
    id: 4,
    name: "Felipe Miranda",
    message: "Fui na loja em busca de um carro e fiz um bom negócio com o Miguel e Thiago... Loja top, recomendo!",
    rating: 5,
  },

];

const FeedbackCarousel = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="mb-10 text-center text-3xl font-bold text-white">
          O que nossos clientes dizem
        </h2>

        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
          className="pb-10"
        >
          {feedbacks.map((feedback) => (
            <SwiperSlide key={feedback.id} className="h-auto">
              <FeedbackCard feedback={feedback} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default FeedbackCarousel;
